// extracted by css-extract-rspack-plugin
export default {"cls1":"LettersModal-cls1_6aZ","cls2":"LettersModal-cls2_qHU LettersModal-cls1_6aZ"};